.searchBarContainer {
  padding: 0;
  width: 100%;
}

.verticalForm {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
}

.formControl {
  width: 100%;
  position: relative;
}

.formControl:nth-child(1) { z-index: 50; }
.formControl:nth-child(2) { z-index: 40; }
.formControl:nth-child(3) { z-index: 30; }
.formControl:nth-child(4) { z-index: 20; }
.formControl:nth-child(5) { z-index: 10; }

.searchForm {
  width: 100%;
}

/* Keep the dropdown chevron always pointing down (prevent icon flip on open) */
.formControl :global(input[aria-expanded="true"]) ~ :global(span[aria-hidden="true"]) svg {
  transform: rotate(180deg);
}
